import { captureMessage } from '@leagueplatform/observability';
import { MasonryEngineActionHandler } from '#types/masonry-engine-action.types.ts';
import { MasonryEngineNodeAction } from '#types/masonry-engine-node.types.ts';

export const fallbackActionHandler: MasonryEngineActionHandler<
  MasonryEngineNodeAction
> = (action) => {
  captureMessage(
    `Masonry Engine: No action - ${action.type} found for namespace - ${action.namespace}`,
  );

  return { isSuccess: true };
};
